import { render, staticRenderFns } from "./user-reviews.vue?vue&type=template&id=f0bffdb8&"
import script from "./user-reviews.vue?vue&type=script&lang=js&"
export * from "./user-reviews.vue?vue&type=script&lang=js&"
import style0 from "./user-reviews.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports